<template>
    <div>
    	<div class="container-fluid main__bg p-0 position-relative"></div>
		<div class="bg-brown">
			<div class="container p-md-5 p-4">
				<div class="row">
					<div class="col-12 text-center text-white pb-md-5 position-relative">
						<h1>{{ $t("main.title") }}</h1>
						<img src="../assets/img/medium-arrow.png" class="img-fluid" draggable="false" style="width: 233px;left: 39%;">
					</div>
					<div class="col-md-5 col-12 text-white order-2 order-md-1 pb-4">
						<img src="../assets/img/single_arrow.jpg" class="img-fluid">
					</div>
					<div class="col-12 col-md-6 text-white order-1 order-md-2">
						<div class="py-3">
							<p>
								{{ $t("main.intro") }}
							</p>
							<p>
								{{ $t("main.intro_second") }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bg-vanilla">
			<div class="container p-md-5 p-4 carousel slide services carousel-dark" id="slider" data-ride="carousel">
				<div class="row carousel-inner">
					<div class="col-12 pb-md-5">
						<div class="position-relative text-center">
							<h2 class="text-dark">{{ $t("what_we_do.title") }}</h2>
							<img src="../assets/img/wide-arrow.png" class="img-fluid" draggable="false" style="width: 300px;left: 35%;">
						</div>
					</div>
					<div class="col-lg-4 col-md-6 col-12 mb-4 mobile-carousel-item active">
						<div class="text-dark box my-2">
							<div class="box__img bg-vanilla box__img--reservation"></div>
							<div class="box__text text-center">
								<h3>{{ $t("what_we_do.subtitle_first") }}</h3>
								<p>{{ $t("what_we_do.text_first") }}</p>
								<router-link class="gradient-border__container" :to="lang == 'hu' ? '/ijaszpalya':'/archery-range'" tag="div">
									<div class="gradient-border__subcontainer">
										<a class="text-brown fw-bold text-decoration-none">
											{{ $t("what_we_do.link_text") }}
										</a>
									</div>
								</router-link>
							</div>
						</div>
		      		</div>
		      		<div class="col-lg-4 col-md-6 col-12 mb-4 mobile-carousel-item">
						<div class="text-dark box my-2">
							<div class="box__img bg-vanilla box__img--teambuilding"></div>
							<div class="box__text text-center">
								<h3>{{ $t("what_we_do.subtitle_sec") }}</h3>
								<p>{{ $t("what_we_do.text_second") }}</p>
							</div>
						</div>
		      		</div>
		      		<div class="col-lg-4 col-md-6 col-12 mb-4 mobile-carousel-item">
						<div class="text-dark box my-2">
							<div class="box__img bg-vanilla box__img--teaching"></div>
							<div class="box__text text-center">
								<h3>{{ $t("what_we_do.subtitle_third") }}</h3>
								<p>{{ $t("what_we_do.text_third") }}</p>
							</div>
						</div>
		      		</div>
		      		<div class="col-lg-4 col-md-6 col-12 mb-4 mobile-carousel-item">
						<div class="text-dark box my-2">
							<div class="box__img bg-vanilla box__img--se"></div>
							<div class="box__text text-center">
								<h3>{{ $t("what_we_do.subtitle_fourth") }}</h3>
								<p>{{ $t("what_we_do.text_fourth") }}</p>
								<router-link class="gradient-border__container" :to="lang == 'hu' ? '/egyesulet':'/association'" tag="div">
									<div class="gradient-border__subcontainer">
										<a class="text-brown fw-bold text-decoration-none">
											{{ $t("what_we_do.link_text") }}
										</a>
									</div>
								</router-link>
							</div>
						</div>
		      		</div>
		      		<div class="col-lg-4 col-md-6 col-12 mb-4 mobile-carousel-item">
						<div class="text-dark box my-2">
							<div class="box__img bg-vanilla box__img--kids"></div>
							<div class="box__text text-center">
								<h3>{{ $t("what_we_do.subtitle_fifth") }}</h3>
								<p>{{ $t("what_we_do.text_fifth") }}</p>
							</div>
						</div>
		      		</div>
		      		<div class="col-lg-4 col-md-6 col-12 mb-4 mobile-carousel-item">
						<div class="text-dark box my-2">
							<div class="box__img bg-vanilla box__img--arrows"></div>
							<div class="box__text text-center">
								<h3>{{ $t("what_we_do.subtitle_six") }}</h3>
								<p>{{ $t("what_we_do.text_six") }}</p>
							</div>
						</div>
		      		</div>
				</div>
				<a class="carousel-control-prev d-md-none d-flex" href="#slider" role="button" data-slide="prev">
			    	<span class="carousel-control-prev-icon" aria-hidden="true"></span>
			    	<span class="sr-only">Previous</span>
			  	</a>
			  	<a class="carousel-control-next d-md-none d-flex" href="#slider" role="button" data-slide="next">
			    	<span class="carousel-control-next-icon" aria-hidden="true"></span>
			    	<span class="sr-only">Next</span>
			  	</a>
			</div>
		</div>
		<div class="bg-brown">
    		<div class="container p-md-5 p-4">
    			<div class="row position-relative">
    				<div class="col-12 pb-md-5 pb-3 position-relative text-center">
						<h2 class="text-white">
							{{ $t("news.title") }}
						</h2>
						<img src="../assets/img/short-arrow.png" class="img-fluid" draggable="false" style="width: 160px;left: 42%;">
					</div>
					<!--<div v-if="!loader" v-for="(set, index) in db" v-bind:key="index" class="row mb-4">
	    				<div class="col-lg-4 col-12">
	    					<img v-bind:src="set.img" class="img-fluid pb-3" draggable="false">
	    				</div>
	    				<div class="col-lg-8 col-12 text-white position-relative">
	    					<h3 class="font--second" v-text="lang == 'hu' ? set.titleHU : set.titleEN"></h3>
	    					<p v-html="lang == 'hu' ? set.introHU : set.introEN"></p>
	    					<router-link class="gradient-border__container--light position-md-absolute" :to="lang == 'hu' ? '/hirek/'+set.linkHU : '/news/'+set.linkEN" v-on:click.native="sendData" tag="div">
								<div class="gradient-border__subcontainer--light text-center">
									<span class="fw-bold text-decoration-none">
										{{ $t("news.read_more") }}
									</span>
								</div>
							</router-link>
	    				</div>
	    			</div>
	    			<div v-if="loader" class="col-12 text-center loading-container">
						<div class="loading-spinner"></div>
					</div>-->
					<div v-if="!loader" class="row">
	    				<div class="col-lg-4 col-12">
	    					<img v-bind:src="first.img" class="img-fluid pb-3" draggable="false">
	    				</div>
	    				<div class="col-lg-8 col-12 text-white position-relative">
	    					<h3 class="font--second" v-text="lang == 'hu' ? first.titleHU : first.titleEN"></h3>
	    					<p v-html="lang == 'hu' ? first.introHU : first.introEN"></p>
	    					<router-link class="gradient-border__container--light position-md-absolute" :to="lang == 'hu' ? '/hirek/'+this.index+'/'+first.linkHU : '/news/'+this.index+'/'+first.linkEN" v-on:click.native="sendData" tag="div">
								<div class="gradient-border__subcontainer--light text-center">
									<span class="fw-bold text-decoration-none">
										{{ $t("news.read_more") }}
									</span>
								</div>
							</router-link>
	    				</div>
	    			</div>
	    			<div v-if="loader" class="col-12 text-center loading-container">
						<div class="loading-spinner"></div>
					</div>
    			</div>
    		</div>
		</div>
		<div v-if="popupShow" class="popup">
			<div class="popup-container">
				<i class="fa fa-times close-icon" aria-hidden="true" v-on:click="popupOk"></i>
				<p>Kedves Íjászok!<br><br>Aug. 25-től pihenni megyünk.<br>Nyitás szept. 2-án!<br><br>Üdvözlettel: <b>A Csodaszarvas csapata</b></p>
			</div>
		</div>
	</div>
</template>

<script>
	import { Bus }  from "../bus.js";
	import firebase from 'firebase/app';
	import 'firebase/database';
	import 'firebase/storage';

    export default {
    	data: function(){
            return {
                lang: "",
                db: [],
                first: [],
                loader: true,
                index: "",
                popupStatus: false,
                popupShow: false
            }
        },
        created: function () {
			this.lang = this.$i18n.locale;
			window.addEventListener("resize", this.checkWindowWidth);

			this.popupStatus = sessionStorage.getItem("popup");
		},
		mounted: function(){
			var self = this;
			let dbRef = firebase.database().ref('news/');

	    	Bus.$on("lang", (lang) => {
				if(lang === "hu"){
					self.lang = "hu";
				}else{
					self.lang = "en";
				}
			});

			if(!this.popupStatus){
				// ezt írd át true-ra ha kell a window.
            	this.popupShow = false;
            }else{
            	this.popupShow = false;
            }

			this.checkWindowWidth();

			dbRef.orderByChild("date").on('value', function(snapshot) {
			    snapshot.forEach(function(childSnapshot) {
				  	if(childSnapshot.val().visible === true){
				  		self.db.push([childSnapshot.key, childSnapshot.val().img]);
				  	}
				});
				self.db.reverse();
				self.getFirstArticle(self.db[0][0]);
			});
		},
		destroyed() {
		  	window.removeEventListener("resize", this.checkWindowWidth);
		},
		methods:{
			popupOk: function(){
				this.popupStatus = true;
				sessionStorage.setItem("popup", this.popupStatus);
				this.popupShow = false;
			},
			checkWindowWidth: function(){
				if(window.screen.width < 578){
	      			document.querySelectorAll('.mobile-carousel-item').forEach(x=>x.classList.add('carousel-item'))
	      			document.querySelectorAll('.carousel-inner').forEach(x=>x.classList.remove('row'))
	      		}else{
	      			document.querySelectorAll('.mobile-carousel-item').forEach(x=>x.classList.remove('carousel-item'))
	      			document.querySelectorAll('.carousel-inner').forEach(x=>x.classList.add('row'))
	      		}
			},
			getFirstArticle: function(id){
				var self = this;
				let dbRef = firebase.database().ref('news/'+id);

				dbRef.on('value', function(snapshot) {
					self.first = snapshot.val();
					self.index = snapshot.key;
				});

				this.getImg(this.first.img[0]);
			},
			sendData: function(){
				Bus.$emit("current", this.index);
			},
			getImg: function(imgName){
				var self = this;
				var storage = firebase.storage().ref('img/'+imgName);
				
				storage.getDownloadURL().then(function(url) {
					self.first.img = url;
					self.loader = false;
				});
			}
		},
    	metaInfo() {
		    return {
				titleTemplate: chunk => (
			        'Csodaszarvas Íjászbarlang'
				),
				meta: [
    			{
    				vmid: 'description',
			        name: 'description',
			        content: this.lang === 'hu' ? 'Gyere íjászkodni a hét minden napján. Fedett, 6 lőállásos pályáinkon készülthetsz versenyekre, de ha még nem próbáltad ezt a sportot, arra is van lehetőség. Vár a Csodaszarvas Íjászbarlang Buda szívében.' : 'In the heart of Buda there is only one archery range awaiting those who are interested in the challenges of archery. Come and try it!',
    			},
    			{
    				vmid: 'og:description',
			        name: 'og:description',
			        content: this.lang === 'hu' ? 'Gyere íjászkodni a hét minden napján. Fedett, 6 lőállásos pályáinkon készülthetsz versenyekre, de ha még nem próbáltad ezt a sportot, arra is van lehetőség. Vár a Csodaszarvas Íjászbarlang Buda szívében.' : 'In the heart of Buda there is only one archery range awaiting those who are interested in the challenges of archery. Come and try it!',
    			},
    			{
    				vmid: 'og:title',
    				property: 'og:title',
        			content: 'Csodaszarvas Íjászbarlang',
    			}
    		]
			};
		}
    };
</script>


// WEBPACK FOOTER //
// src/components/Main.vue